(() => {
  const cardSelector = '[data-yx-product-card]';
  let activeMobileInfoCard = null;
  const isSpanish = document.documentElement.lang.toLowerCase().startsWith('es');
  const quickBuyTranslations = typeof Theme !== 'undefined' ? Theme.translations || {} : {};
  const quickBuyRoutes = typeof Theme !== 'undefined' ? Theme.routes || {} : {};

  function localizedOptionValue(value) {
    if (!isSpanish) return value;
    const labels = {
      white: 'Blanco', black: 'Negro', gray: 'Gris', grey: 'Gris', 'dark gray': 'Gris oscuro',
      'dark grey': 'Gris oscuro', 'light gray': 'Gris claro', 'light grey': 'Gris claro',
      'dark blue': 'Azul marino', navy: 'Azul marino', 'navy blue': 'Azul marino', 'gray blue': 'Azul grisáceo',
      blue: 'Azul', 'light blue': 'Azul claro', green: 'Verde', yellow: 'Amarillo', lemon: 'Amarillo',
      lemony: 'Amarillo', 'hi-vis yellow': 'Amarillo de alta visibilidad', orange: 'Naranja', red: 'Rojo',
      brown: 'Marrón', khaki: 'Caqui', 'gray khaki': 'Caqui gris', beige: 'Beige', 'dark beige': 'Beige oscuro',
      graphite: 'Grafito',
    };
    return String(value || '').split('/').map((part) => labels[part.trim().toLowerCase()] || part.trim()).join('/');
  }

  function isMobileQuickBuyViewport() {
    return window.matchMedia('(max-width: 1199px)').matches;
  }

  function isMobileProductInfoViewport() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function syncMobileQuickBuyDocumentState() {
    const hasOpenQuickBuy = isMobileQuickBuyViewport()
      && Boolean(document.querySelector(`${cardSelector}[data-yx-quick-buy-open]`));
    document.documentElement.classList.toggle('yx-mobile-quick-buy-open', hasOpenQuickBuy);
  }

  function syncQuickBuyModalSemantics(card) {
    const panel = card?.querySelector('[data-yx-quick-buy-panel]');
    if (!panel) return;
    const isModal = card.hasAttribute('data-yx-quick-buy-open') && isMobileQuickBuyViewport();
    if (isModal) {
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      panel.setAttribute('tabindex', '-1');
    } else {
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
      panel.removeAttribute('tabindex');
    }
  }

  function syncQuickBuyAddedState(card, isAdded) {
    const panel = card?.querySelector('[data-yx-quick-buy-panel]');
    panel?.querySelector('.yx-product-card__quick-buy-selection-state')?.setAttribute('aria-hidden', String(isAdded));
    panel?.querySelector('.yx-product-card__quick-buy-added-state')?.setAttribute('aria-hidden', String(!isAdded));
  }

  function mobileInfoSheet() {
    let sheet = document.querySelector('[data-yx-mobile-product-info-sheet]');
    if (sheet) return sheet;

    sheet = document.createElement('div');
    sheet.className = 'yx-mobile-product-info-sheet';
    sheet.hidden = true;
    sheet.setAttribute('aria-hidden', 'true');
    sheet.setAttribute('data-yx-mobile-product-info-sheet', '');
    sheet.innerHTML = `
      <button class="yx-mobile-product-info-sheet__backdrop" type="button" tabindex="-1" aria-label="${isSpanish ? 'Cerrar información del producto' : 'Close product information'}" data-yx-mobile-product-info-close></button>
      <section class="yx-mobile-product-info-sheet__surface" role="dialog" aria-modal="true" aria-labelledby="yx-mobile-product-info-title" tabindex="-1">
        <span class="yx-mobile-product-info-sheet__handle" aria-hidden="true"></span>
        <header class="yx-mobile-product-info-sheet__head">
          <h2 id="yx-mobile-product-info-title">${isSpanish ? 'Información del producto' : 'Product information'}</h2>
          <button class="yx-mobile-product-info-sheet__close" type="button" aria-label="${isSpanish ? 'Cerrar información del producto' : 'Close product information'}" data-yx-mobile-product-info-close>
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18" stroke="currentColor" stroke-width="1.7"/></svg>
          </button>
        </header>
        <p class="yx-mobile-product-info-sheet__product" data-yx-mobile-product-info-product></p>
        <div class="yx-mobile-product-info-sheet__summary" data-yx-mobile-product-info-summary></div>
      </section>
    `;
    document.body.append(sheet);
    return sheet;
  }

  function closeMobileProductInfoSheet({ returnFocus = true } = {}) {
    const card = activeMobileInfoCard || document.querySelector(`${cardSelector}[data-yx-info-open]`);
    const sheet = document.querySelector('[data-yx-mobile-product-info-sheet]');

    if (card) {
      card.removeAttribute('data-yx-info-open');
      card.querySelector('[data-yx-product-info]')?.setAttribute('aria-expanded', 'false');
      card.querySelector('.yx-product-card__details')?.setAttribute('aria-hidden', 'true');
    }
    activeMobileInfoCard = null;
    document.documentElement.classList.remove('yx-mobile-product-info-open');
    if (sheet) {
      sheet.removeAttribute('data-yx-open');
      sheet.hidden = true;
      sheet.setAttribute('aria-hidden', 'true');
    }
    if (returnFocus) card?.querySelector('[data-yx-product-info]')?.focus();
  }

  function openMobileProductInfoSheet(card) {
    const sheet = mobileInfoSheet();
    const title = card.querySelector('.yx-product-card__title, .yx-home__look-card-name, .main-product__look-name')?.textContent?.replace(/\s+/g, ' ').trim() || (isSpanish ? 'Información del producto' : 'Product information');
    const summary = card.querySelector('.yx-product-card__summary');

    document.querySelectorAll(`${cardSelector}[data-yx-info-open]`).forEach((openCard) => {
      if (openCard === card) return;
      openCard.removeAttribute('data-yx-info-open');
      openCard.querySelector('[data-yx-product-info]')?.setAttribute('aria-expanded', 'false');
      openCard.querySelector('.yx-product-card__details')?.setAttribute('aria-hidden', 'true');
    });
    card.setAttribute('data-yx-info-open', '');
    card.querySelector('[data-yx-product-info]')?.setAttribute('aria-expanded', 'true');
    card.querySelector('.yx-product-card__details')?.setAttribute('aria-hidden', 'true');
    sheet.querySelector('[data-yx-mobile-product-info-product]').textContent = title;
    const sheetSummary = sheet.querySelector('[data-yx-mobile-product-info-summary]');
    sheetSummary.replaceChildren();
    if (summary) {
      [...summary.childNodes].forEach((node) => sheetSummary.append(node.cloneNode(true)));
    }
    sheet.hidden = false;
    sheet.setAttribute('aria-hidden', 'false');
    activeMobileInfoCard = card;
    document.documentElement.classList.add('yx-mobile-product-info-open');
    window.requestAnimationFrame(() => {
      sheet.setAttribute('data-yx-open', '');
      sheet.querySelector('.yx-mobile-product-info-sheet__close')?.focus();
    });
  }

  function trapMobileProductInfoFocus(event) {
    if (event.key !== 'Tab' || !isMobileProductInfoViewport() || !activeMobileInfoCard) return false;
    const sheet = document.querySelector('[data-yx-mobile-product-info-sheet][data-yx-open]');
    if (!sheet) return false;
    const focusable = [...sheet.querySelectorAll('a[href], button:not([disabled]):not([tabindex="-1"]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')];
    const surface = sheet.querySelector('.yx-mobile-product-info-sheet__surface');
    if (!focusable.length) {
      event.preventDefault();
      surface?.focus();
      return true;
    }
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || !sheet.contains(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !sheet.contains(document.activeElement))) {
      event.preventDefault();
      first.focus();
    }
    return true;
  }

  function trapMobileQuickBuyFocus(event) {
    if (event.key !== 'Tab' || !isMobileQuickBuyViewport()) return false;
    const card = document.querySelector(`${cardSelector}[data-yx-quick-buy-open]`);
    const panel = card?.querySelector('[data-yx-quick-buy-panel][aria-modal="true"]');
    if (!panel) return false;

    const activeState = card.hasAttribute('data-yx-quick-buy-added')
      ? panel.querySelector('.yx-product-card__quick-buy-added-state')
      : panel.querySelector('.yx-product-card__quick-buy-selection-state');
    const focusable = [...(activeState?.querySelectorAll('a[href], button:not([disabled]):not([tabindex="-1"]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])') || [])]
      .filter((element) => element.getClientRects().length > 0);

    if (!focusable.length) {
      event.preventDefault();
      panel.focus();
      return true;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) {
      event.preventDefault();
      first.focus();
    }
    return true;
  }

  function setProductInfoState(card, isOpen) {
    const trigger = card.querySelector('[data-yx-product-info]');
    const details = card.querySelector('.yx-product-card__details');

    if (isOpen) setQuickBuyState(card, false);
    if (isMobileProductInfoViewport()) {
      if (isOpen) openMobileProductInfoSheet(card);
      else closeMobileProductInfoSheet();
      return;
    }
    card.toggleAttribute('data-yx-info-open', isOpen);
    trigger?.setAttribute('aria-expanded', String(isOpen));
    details?.setAttribute('aria-hidden', String(!isOpen));
  }

  function readJson(node, selector) {
    const source = node?.querySelector(selector);
    if (!source) return [];
    try {
      const value = JSON.parse(source.textContent || '[]');
      return Array.isArray(value) ? value : [];
    } catch {
      return [];
    }
  }

  function readJsonObject(node, selector) {
    const source = node?.querySelector(selector);
    if (!source) return {};
    try {
      const value = JSON.parse(source.textContent || '{}');
      return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
    } catch {
      return {};
    }
  }

  function quickBuyParts(card) {
    const panel = card.querySelector('[data-yx-quick-buy-panel]');
    return {
      panel,
      trigger: card.querySelector('[data-yx-quick-buy-trigger]'),
      confirm: panel?.querySelector('[data-yx-quick-buy-confirm]'),
      status: panel?.querySelector('[data-yx-quick-buy-status]'),
      price: panel?.querySelector('[data-yx-quick-buy-price]'),
      compare: panel?.querySelector('[data-yx-quick-buy-compare]'),
      discount: panel?.querySelector('[data-yx-quick-buy-discount]'),
      image: panel?.querySelector('.yx-product-card__quick-buy-image'),
      colors: panel?.querySelector('[data-yx-quick-buy-colors]'),
      quantity: panel?.querySelector('[data-yx-quick-buy-quantity-value]'),
      values: [...(panel?.querySelectorAll('[data-yx-quick-buy-value]') || [])]
    };
  }

  function getVariants(panel) {
    return readJson(panel, '[data-yx-quick-buy-variants]');
  }

  function getOptions(panel) {
    return readJson(panel, '[data-yx-quick-buy-options]');
  }

  function getVariantPrices(panel) {
    return readJsonObject(panel, '[data-yx-quick-buy-prices]');
  }

  function getCurrentVariant(card, variants) {
    const selectedId = card.querySelector('[data-yx-variant-input]')?.value;
    return variants.find((variant) => String(variant.id) === String(selectedId))
      || variants.find((variant) => variant.available)
      || variants[0];
  }

  function variantImageUrl(variant) {
    const image = variant?.featured_image || variant?.featured_media?.preview_image;
    if (typeof image === 'string') return image;
    return image?.url || image?.src || '';
  }

  function discountPercent(variant) {
    const price = Number(variant?.price || 0);
    const compareAt = Number(variant?.compare_at_price || 0);
    return compareAt > price ? Math.round(((compareAt - price) / compareAt) * 100) : 0;
  }

  function optionIndex(button) {
    return Number(button.dataset.yxQuickBuyOptionIndex);
  }

  function matchingVariant(variants, choices, selectedIndexes = new Set()) {
    const exact = variants.find((variant) => variant.options?.every((value, index) => choices[index] === value));
    if (exact?.available) return exact;

    const preservedIndexes = [...selectedIndexes];
    const availableMatch = variants.find((variant) => variant.available && preservedIndexes.every((index) => (
      variant.options?.[index] === choices[index]
    )));
    if (availableMatch) return availableMatch;

    if (preservedIndexes.length) {
      return exact
        || variants.find((variant) => preservedIndexes.every((index) => variant.options?.[index] === choices[index]))
        || variants[0];
    }

    return variants.find((variant) => variant.available) || exact || variants[0];
  }

  function colorOptionIndexes(panel) {
    return getOptions(panel)
      .map((option, index) => /colou?r/i.test(option.name || '') ? index : -1)
      .filter((index) => index >= 0);
  }

  function requiredOptionIndexes(panel) {
    return getOptions(panel)
      .map((option, index) => {
        if (/colou?r/i.test(option.name || '')) return -1;
        const values = option.values || [];
        if (/^title$/i.test(option.name || '') && values.length === 1 && /^default title$/i.test(values[0] || '')) return -1;
        return index;
      })
      .filter((index) => index >= 0);
  }

  function selectedOptionIndexes(card, panel) {
    if (card._yxQuickBuySelectedOptions) return card._yxQuickBuySelectedOptions;
    return new Set(colorOptionIndexes(panel));
  }

  function hasRequiredOptionSelections(card, panel) {
    const selectedIndexes = selectedOptionIndexes(card, panel);
    return requiredOptionIndexes(panel).every((index) => selectedIndexes.has(index));
  }

  function isValueAvailable(variants, choices, selectedIndexes, index, value) {
    return variants.some((candidate) => candidate.available
      && candidate.options?.[index] === value
      && [...selectedIndexes].every((selectedIndex) => selectedIndex === index
        || candidate.options?.[selectedIndex] === choices[selectedIndex]));
  }

  function buildColorControls(card) {
    const { panel, colors } = quickBuyParts(card);
    if (!panel || !colors || colors.childElementCount) return;
    const variants = getVariants(panel);
    const options = getOptions(panel);
    const colorIndex = options.findIndex((option) => /colou?r/i.test(option.name || ''));
    if (colorIndex < 0) {
      colors.hidden = true;
      return;
    }
    const cardSwatches = new Map([...card.querySelectorAll('.yx-product-card__swatch')].map((swatch) => [
      swatch.dataset.yxOptionValue || swatch.getAttribute('aria-label') || '',
      {
        a: swatch.style.getPropertyValue('--yx-swatch-a') || '#d8d8d8',
        b: swatch.style.getPropertyValue('--yx-swatch-b') || '#2f2f2f'
      }
    ]));
    (options[colorIndex].values || []).forEach((value) => {
      const swatch = cardSwatches.get(value);
      const button = document.createElement('button');
      button.className = 'yx-product-card__quick-buy-color';
      button.type = 'button';
      button.setAttribute('data-yx-quick-buy-value', '');
      button.dataset.yxQuickBuyOptionValue = value;
      button.dataset.yxQuickBuyOptionIndex = String(colorIndex);
      button.setAttribute('role', 'radio');
      button.setAttribute('aria-label', `${isSpanish ? 'Color' : options[colorIndex].name}: ${localizedOptionValue(value)}`);
      button.setAttribute('aria-checked', 'false');
      button.style.setProperty('--yx-swatch-a', swatch?.a || '#d8d8d8');
      button.style.setProperty('--yx-swatch-b', swatch?.b || '#2f2f2f');
      button.toggleAttribute('data-yx-quick-buy-discount', variants.some((variant) => (
        variant.options?.[colorIndex] === value && discountPercent(variant) > 0
      )));
      colors.append(button);
    });
  }

  function syncQuickBuyScale(card) {
    const media = card.querySelector('.yx-product-card__media');
    if (!media) return;
    const box = media.getBoundingClientRect();
    const scale = Math.min(1, box.width / 414, box.height / 497);
    card.style.setProperty('--yx-quick-buy-scale', String(Math.max(0, scale)));
  }

  function syncQuickBuy(card) {
    const { panel, confirm, price, compare, discount, image, quantity, values } = quickBuyParts(card);
    if (!panel) return;
    const variants = getVariants(panel);
    const selectedIndexes = selectedOptionIndexes(card, panel);
    const current = matchingVariant(variants, card._yxQuickBuyChoices || getCurrentVariant(card, variants)?.options || [], selectedIndexes);
    if (!current) return;

    card._yxQuickBuyChoices = [...(current.options || [])];
    card.dataset.yxQuickBuyVariantId = String(current.id);
    const variantInput = card.querySelector('[data-yx-variant-input]');
    if (variantInput) variantInput.value = String(current.id);
    const discounted = discountPercent(current);
    const formattedPrices = getVariantPrices(panel)[String(current.id)] || {};
    if (price && formattedPrices.price) price.textContent = formattedPrices.price;
    if (compare) {
      compare.hidden = !discounted;
      compare.textContent = discounted ? (formattedPrices.compare_at_price || '') : '';
    }
    if (discount) {
      discount.hidden = !discounted;
      discount.textContent = discounted ? `Save ${discounted}%` : '';
    }
    if (image && !image._yxQuickBuyDefaultImage) image._yxQuickBuyDefaultImage = image.currentSrc || image.src;
    const selectedImageUrl = variantImageUrl(current) || image?._yxQuickBuyDefaultImage || '';
    if (image && selectedImageUrl) {
      image.src = selectedImageUrl;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
    }
    if (quantity) quantity.textContent = String(card._yxQuickBuyQuantity || 1);
    confirm?.toggleAttribute('disabled', !current.available || !hasRequiredOptionSelections(card, panel));

    values.forEach((button) => {
      const index = optionIndex(button);
      const value = button.dataset.yxQuickBuyOptionValue || '';
      const available = isValueAvailable(variants, card._yxQuickBuyChoices, selectedIndexes, index, value);
      const selected = selectedIndexes.has(index) && current.options?.[index] === value;
      button.disabled = !available;
      button.toggleAttribute('data-selected', selected);
      button.setAttribute('aria-checked', String(selected));
    });

    panel.querySelectorAll('[data-yx-quick-buy-option-row]').forEach((row) => {
      const index = Number(row.dataset.yxQuickBuyOptionIndex);
      const currentValue = row.querySelector('[data-yx-quick-buy-option-current]');
      if (currentValue) currentValue.textContent = selectedIndexes.has(index) ? localizedOptionValue(current.options?.[index] || '') : (isSpanish ? 'Seleccionar' : 'Select');
    });
  }

  function setQuickBuyState(card, isOpen) {
    const { panel, trigger, status } = quickBuyParts(card);
    if (!panel || !trigger) return;

    if (isOpen && isMobileQuickBuyViewport()) {
      document.querySelectorAll(`${cardSelector}[data-yx-quick-buy-open]`).forEach((openCard) => {
        if (openCard === card) return;
        openCard.removeAttribute('data-yx-quick-buy-added');
        openCard.removeAttribute('data-yx-quick-buy-open');
        openCard.querySelector('[data-yx-quick-buy-trigger]')?.setAttribute('aria-expanded', 'false');
        openCard.querySelector('[data-yx-quick-buy-panel]')?.setAttribute('aria-hidden', 'true');
        syncQuickBuyModalSemantics(openCard);
      });
    }

    if (isOpen && isMobileProductInfoViewport()) closeMobileProductInfoSheet({ returnFocus: false });

    card.toggleAttribute('data-yx-quick-buy-open', isOpen);
    trigger.setAttribute('aria-expanded', String(isOpen));
    panel.setAttribute('aria-hidden', String(!isOpen));
    syncQuickBuyModalSemantics(card);
    if (!isOpen) {
      syncMobileQuickBuyDocumentState();
      return;
    }

    card.removeAttribute('data-yx-info-open');
    card.querySelector('[data-yx-product-info]')?.setAttribute('aria-expanded', 'false');
    card.removeAttribute('data-yx-quick-buy-added');
    syncQuickBuyAddedState(card, false);
    card._yxQuickBuyQuantity = 1;
    card._yxQuickBuyChoices = [...(getCurrentVariant(card, getVariants(panel))?.options || [])];
    card._yxQuickBuySelectedOptions = new Set(colorOptionIndexes(panel));
    syncQuickBuyScale(card);
    buildColorControls(card);
    if (status) status.textContent = '';
    syncQuickBuy(card);
    syncMobileQuickBuyDocumentState();

    if (isMobileQuickBuyViewport()) {
      window.requestAnimationFrame(() => panel.querySelector('[data-yx-quick-buy-close]')?.focus());
    }
  }

  function selectQuickBuyValue(card, button) {
    if (button.disabled) return;
    const { panel, status } = quickBuyParts(card);
    const variants = getVariants(panel);
    const index = optionIndex(button);
    const value = button.dataset.yxQuickBuyOptionValue || '';
    const choices = [...(card._yxQuickBuyChoices || getCurrentVariant(card, variants)?.options || [])];
    choices[index] = value;
    const selectedIndexes = selectedOptionIndexes(card, panel);
    selectedIndexes.add(index);
    const next = variants.find((variant) => isValueAvailable([variant], choices, selectedIndexes, index, value))
      || variants.find((variant) => variant.available && variant.options?.[index] === value);
    if (!next) return;
    card._yxQuickBuyChoices = [...(next.options || [])];
    if (status) status.textContent = `${localizedOptionValue(value)} ${quickBuyTranslations.quick_buy_selected || (isSpanish ? 'seleccionado' : 'selected')}`;
    syncQuickBuy(card);
  }

  function updateQuantity(card, delta) {
    card._yxQuickBuyQuantity = Math.max(1, Number(card._yxQuickBuyQuantity || 1) + delta);
    quickBuyParts(card).quantity?.replaceChildren(document.createTextNode(String(card._yxQuickBuyQuantity)));
  }

  async function submitQuickBuy(card) {
    const { panel, confirm, status } = quickBuyParts(card);
    const variant = matchingVariant(getVariants(panel), card._yxQuickBuyChoices || [], selectedOptionIndexes(card, panel));
    const form = card.querySelector('form[action*="/cart/add"]');
    if (!variant?.available || !form || !confirm || confirm.disabled || !hasRequiredOptionSelections(card, panel)) return;

    confirm.disabled = true;
    confirm.setAttribute('aria-busy', 'true');
    try {
      const data = new FormData(form);
      data.set('id', String(variant.id));
      data.set('quantity', String(card._yxQuickBuyQuantity || 1));
      const response = await fetch(quickBuyRoutes.cart_add_url || '/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data });
      if (!response.ok) throw new Error('Quick buy failed');
      const resource = await response.json();
      let cartItemCount = Number(card._yxQuickBuyQuantity || 1);
      try {
        const cartStateUrl = `${quickBuyRoutes.cart_url || '/cart'}.js`;
        const cartResponse = await fetch(cartStateUrl, { headers: { Accept: 'application/json' } });
        if (cartResponse.ok) {
          const cartState = await cartResponse.json();
          const total = Number(cartState?.item_count);
          if (Number.isFinite(total)) cartItemCount = total;
        }
      } catch {
        // Keep the just-added quantity only when the current cart state cannot be read.
      }
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource, data: { source: 'product-card-quick-buy', itemCount: cartItemCount, variantId: String(variant.id) } }
      }));
      if (status) status.textContent = quickBuyTranslations.quick_buy_added || (isSpanish ? 'Añadido al carrito' : 'Added to cart');
      const addedPrice = panel?.querySelector('[data-yx-quick-buy-added-price]');
      const formattedPrice = getVariantPrices(panel)[String(variant.id)]?.price;
      if (addedPrice && formattedPrice) addedPrice.textContent = formattedPrice;
      const addedImage = panel?.querySelector('.yx-product-card__quick-buy-added-image');
      const selectedImageUrl = variantImageUrl(variant);
      if (addedImage && selectedImageUrl) {
        addedImage.src = selectedImageUrl;
        addedImage.removeAttribute('srcset');
        addedImage.removeAttribute('sizes');
      }
      card.setAttribute('data-yx-quick-buy-added', '');
      syncQuickBuyAddedState(card, true);
      const addedVariant = panel?.querySelector('[data-yx-quick-buy-added-variant]');
      const addedVariantValues = (variant.options || []).filter((value) => value && !/^default title$/i.test(value));
      if (addedVariant) {
        addedVariant.textContent = addedVariantValues.join(', ');
        addedVariant.hidden = addedVariantValues.length === 0;
      }
      if (isMobileQuickBuyViewport()) {
        window.requestAnimationFrame(() => panel?.querySelector('.yx-product-card__quick-buy-added-state [data-yx-quick-buy-close]')?.focus());
      }
    } catch {
      if (status) status.textContent = quickBuyTranslations.quick_buy_error || (isSpanish ? 'No se pudo añadir esta variante. Inténtalo de nuevo.' : 'Could not add this variant. Please try again.');
      confirm.disabled = false;
    } finally {
      confirm.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', (event) => {
    const infoClose = event.target.closest('[data-yx-mobile-product-info-close]');
    if (infoClose) {
      event.preventDefault();
      closeMobileProductInfoSheet();
      return;
    }

    const quickBuyPanel = event.target.closest('[data-yx-quick-buy-panel]');
    if (quickBuyPanel && event.target === quickBuyPanel && isMobileQuickBuyViewport()) {
      const card = quickBuyPanel.closest(`${cardSelector}[data-yx-quick-buy-card]`);
      if (!card) return;
      event.preventDefault();
      card.removeAttribute('data-yx-quick-buy-added');
      setQuickBuyState(card, false);
      card.querySelector('[data-yx-quick-buy-trigger]')?.focus();
      return;
    }

    const infoTrigger = event.target.closest('[data-yx-product-info]');
    if (infoTrigger) {
      const card = infoTrigger.closest(`${cardSelector}[data-yx-info-card]`);
      if (!card) return;
      event.preventDefault();
      event.stopPropagation();
      setProductInfoState(card, !card.hasAttribute('data-yx-info-open'));
      return;
    }

    const quickBuyTrigger = event.target.closest('[data-yx-quick-buy-trigger]');
    if (quickBuyTrigger) {
      const card = quickBuyTrigger.closest(`${cardSelector}[data-yx-quick-buy-card]`);
      if (!card) return;
      event.preventDefault();
      event.stopPropagation();
      setQuickBuyState(card, !card.hasAttribute('data-yx-quick-buy-open'));
      return;
    }

    const value = event.target.closest('[data-yx-quick-buy-value]');
    if (value) {
      const card = value.closest(`${cardSelector}[data-yx-quick-buy-card]`);
      if (!card) return;
      event.preventDefault();
      selectQuickBuyValue(card, value);
      return;
    }

    const quantity = event.target.closest('[data-yx-quick-buy-quantity]');
    if (quantity) {
      const card = quantity.closest(`${cardSelector}[data-yx-quick-buy-card]`);
      if (!card) return;
      event.preventDefault();
      updateQuantity(card, Number(quantity.dataset.yxQuickBuyQuantity || 0));
      return;
    }

    const confirm = event.target.closest('[data-yx-quick-buy-confirm]');
    if (confirm) {
      const card = confirm.closest(`${cardSelector}[data-yx-quick-buy-card]`);
      if (!card) return;
      event.preventDefault();
      submitQuickBuy(card);
      return;
    }

    const close = event.target.closest('[data-yx-quick-buy-close]');
    if (close) {
      const card = close.closest(`${cardSelector}[data-yx-quick-buy-card]`);
      if (!card) return;
      event.preventDefault();
      card.removeAttribute('data-yx-quick-buy-added');
      setQuickBuyState(card, false);
      card.querySelector('[data-yx-quick-buy-trigger]')?.focus();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (trapMobileProductInfoFocus(event)) return;
    if (trapMobileQuickBuyFocus(event)) return;
    if (event.key !== 'Escape') return;
    if (isMobileProductInfoViewport() && activeMobileInfoCard) {
      closeMobileProductInfoSheet();
      return;
    }
    const quickBuyCard = event.target.closest?.(`${cardSelector}[data-yx-quick-buy-open]`)
      || document.querySelector(`${cardSelector}[data-yx-quick-buy-open]`);
    if (quickBuyCard) {
      setQuickBuyState(quickBuyCard, false);
      quickBuyCard.querySelector('[data-yx-quick-buy-trigger]')?.focus();
      return;
    }
    const infoCard = event.target.closest?.(`${cardSelector}[data-yx-info-open]`)
      || document.querySelector(`${cardSelector}[data-yx-info-open]`);
    if (infoCard) {
      setProductInfoState(infoCard, false);
      infoCard.querySelector('[data-yx-product-info]')?.focus();
    }
  });

  document.addEventListener('yx:grid-view:before-change', () => {
    document.querySelectorAll(`${cardSelector}[data-yx-quick-buy-open]`).forEach((card) => {
      const panel = card.querySelector('[data-yx-quick-buy-panel]');
      panel?.style.setProperty('transition', 'none', 'important');
      card.removeAttribute('data-yx-quick-buy-added');
      setQuickBuyState(card, false);
      panel?.getBoundingClientRect();
      window.requestAnimationFrame(() => panel?.style.removeProperty('transition'));
    });
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll(`${cardSelector}[data-yx-quick-buy-open]`).forEach((card) => {
      syncQuickBuyScale(card);
      syncQuickBuyModalSemantics(card);
    });
    syncMobileQuickBuyDocumentState();
    if (!isMobileProductInfoViewport() && activeMobileInfoCard) closeMobileProductInfoSheet({ returnFocus: false });
  });
})();
